(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderDialogController', HistoryLoaderDialogController);

    HistoryLoaderDialogController.$inject = ['$uibModalInstance', '$filter', 'MegafonHistoryLoader', 'CianHistoryLoader', 'AlertService', 'entity', '$state'];

    function HistoryLoaderDialogController($uibModalInstance, $filter, MegafonHistoryLoader, CianHistoryLoader, AlertService, entity, $state) {
        var vm = this;

        vm.clear = clear;
        vm.confirmLoadHistory = confirmLoadHistory;
        vm.limit = entity.limit;
        vm.startTime = entity.startTime;
        vm.endTime = entity.endTime;
        vm.historyProviderSelector = entity.historyProviderSelector;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmLoadHistory() {
            if(vm.historyProviderSelector == 'Megafon') {
                MegafonHistoryLoader.loadHistory({
                    start:$filter('date')(vm.startTime, "yyyy-MM-ddT00:00:00.000", 0),
                    end:$filter('date')(vm.endTime, "yyyy-MM-ddT23:59:59.999", 0),
                    limit:vm.limit}, onSaveSuccess, onSaveError);
                $uibModalInstance.close(true);
                $state.go('history-loader.loading');
            } else if(vm.historyProviderSelector == 'Cian') {
                CianHistoryLoader.loadHistory({
                    start:$filter('date')(vm.startTime, "yyyy-MM-ddT00:00:00.000", 0),
                    end:$filter('date')(vm.endTime, "yyyy-MM-ddT23:59:59.999", 0),
                    limit:vm.limit}, onSaveSuccess, onSaveError);
                $uibModalInstance.close(true);
                $state.go('history-loader.loading');
            } else {
                
            }
        }

        function onSaveSuccess(result) {
            if(result.count > 0) {
                AlertService.warning("history-loader.newRecordsLoaded", result);
            } else {
                AlertService.warning("history-loader.noNewRecords");
            }
            $state.go('history-loader');
        }

        function onSaveError (result) {
            if(result.data) {
                if(result.data.concurrentError == true) {
                    AlertService.warning("history-loader.concurrentModificationError");
                } else if(result.data.streamError == true) {
                    AlertService.warning("history-loader.streamError", {provider: vm.historyProviderSelector});
                } else {
                    AlertService.warning("history-loader.unknownError");
                }
            }
            $state.go('history-loader');
        }
    }
})();
